module.exports = __webpack_public_path__ + "img/BO.1c0bf94f.svg";